// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    field_for_all_activities: 'This field is for activities only <b style=\"white-space: nowrap;\">({0} tasks, {1} risks, {2} requests)</b>',
    field_for_issues: 'This field is for <b style=\"white-space: nowrap;\">{0} risks</b> only',
};
